import { Domains } from "@/env";

const DOMAINS = new Domains({ usePrefix: true });
export const GOOGLE_AUTH_CALLBACK_URL = `${DOMAINS.domains.admin}/google_auth_redirect`;
export const MICROSOFT_AUTH_CALLBACK_URL = `${DOMAINS.domains.admin}/microsoft_auth_redirect`;
